import './landing.css'

/* ----------------------------------------------------------------------------
   Page « Nous contacter ». Reprend les canaux de livingdata.co (email, X,
   LinkedIn) dans le langage visuel de la landing (.ld-home : paper, navy,
   Montserrat). Aucun formulaire pour l'instant : contact direct.
---------------------------------------------------------------------------- */

const CONTACT_EMAIL = 'contact@livingdata.co'
const X_URL = 'https://x.com/_LivingData'
const LINKEDIN_URL = 'https://www.linkedin.com/company/livingdata'

function MailIcon() {
  return (
    <svg width='26' height='26' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='1.7' strokeLinecap='round' strokeLinejoin='round' aria-hidden='true'>
      <rect x='3' y='5' width='18' height='14' rx='2' /><path d='m3 7 9 6 9-6' />
    </svg>
  )
}

function LinkedInIcon() {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='currentColor' aria-hidden='true'>
      <path d='M4.98 3.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5ZM3 9h4v12H3zM10 9h3.8v1.7h.05c.53-.95 1.83-1.95 3.76-1.95 4.02 0 4.76 2.5 4.76 5.75V21h-4v-5.3c0-1.26-.02-2.9-1.77-2.9-1.77 0-2.04 1.38-2.04 2.8V21h-4z' />
    </svg>
  )
}

function XIcon() {
  return (
    <svg width='22' height='22' viewBox='0 0 24 24' fill='currentColor' aria-hidden='true'>
      <path d='M18.9 2H22l-7.5 8.6L23 22h-6.8l-5.3-7-6.1 7H1.7l8-9.2L1 2h7l4.8 6.4L18.9 2Zm-2.4 18h1.9L7.6 4H5.6z' />
    </svg>
  )
}

const CHANNELS = [
  {key: 'email', icon: <MailIcon />, title: 'Nous écrire', label: CONTACT_EMAIL, href: `mailto:${CONTACT_EMAIL}`, external: false},
  {key: 'linkedin', icon: <LinkedInIcon />, title: 'Nous retrouver sur LinkedIn', label: 'Living Data', href: LINKEDIN_URL, external: true},
  {key: 'x', icon: <XIcon />, title: 'Nous suivre sur X', label: '@_LivingData', href: X_URL, external: true}
]

export function ContactPage() {
  return (
    <div className='ld-home'>
      <section className='ld-section ld-section--pad'>
        <div className='ld-wrap'>
          <p className='ld-eyebrow'>Contact</p>
          <h1 className='ld-h1'>Une question&nbsp;? Parlons-en.</h1>
          <p className='ld-lead' style={{maxWidth: '42rem'}}>
            Une démo, un devis, ou simplement une question sur Living Data Studio — écrivez-nous, on répond vite. Vous pouvez aussi nous suivre sur les réseaux.
          </p>

          <div className='ld-contact__grid'>
            {CHANNELS.map(channel => (
              <a
                key={channel.key}
                className='ld-contact__card'
                href={channel.href}
                target={channel.external ? '_blank' : undefined}
                rel={channel.external ? 'noreferrer' : undefined}
              >
                <span className='ld-contact__icon'>{channel.icon}</span>
                <span className='ld-contact__title'>{channel.title}</span>
                <span className='ld-contact__label'>{channel.label}</span>
              </a>
            ))}
          </div>
        </div>
      </section>
    </div>
  )
}
